import auth from "./middleware/auth.js";
export default [
  {
    path: "/tenant",
    component: () => import("@/views/tenant"),
    children: [
      {
        path: "",
        name: "tenant-home",
        component: () => import("@/views/tenant/home"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "analytics",
        name:'tenant-users-analytics',
        component: () => import("@/views/tenant/analytics/Index"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "course-completion",
        name:'tenant-users-completion',
        component: () => import("@/views/tenant/analytics/CourseCompletion"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "support/tny/leaderboard",
        name:'tenant-leaderboard',
        component: () => import("@/views/tenant/tny/Index"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "support/active",
        name:'tenant-active-users',
        component: () => import("@/views/tenant/support/Active"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "support/inactive",
        name:'tenant-inactive-users',
        component: () => import("@/views/tenant/support/Inactive"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "support/gift-analysis",
        name:'tenant-gift-analysis',
        component: () => import("@/views/tenant/support/Gift"),
        meta: {
          middleware: [auth],
        }
      },
      {
        path: "programs",
        component: () => import("@/views/tenant/programs/index"),

        children: [
          {
            path: "",
            name: "tenant-programs",
            component: () => import("@/views/tenant/programs/home"),
            meta: {
              middleware: [auth],
            },
          },
        
          {
            path: "reminders/singe/:id",
            name: "tenant-program-reminder",
            component: () => import("@/views/tenant/programs/reminders/single"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "create-program",
            component: () => import("@/views/tenant/programs/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "edit-program",
            component: () => import("@/views/tenant/programs/edit"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "courses/:id",
            name: "tenant-program-courses",
            component: () => import("@/views/tenant/programs/course"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "discussion",
        component: () => import("@/views/tenant/discussion/index"),
        children: [
          {
            path: "",
            name: "tenant-discussion-home",
            component: () => import("@/views/tenant/discussion/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "single/:id",
            name: "tenant-discussion-single",
            component: () => import("@/views/tenant/discussion/single"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "user/details/:user",
            name: "tenant-discussion-user",
            component: () => import("@/views/tenant/discussion/user"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "users",
        component: () => import("@/views/tenant/users/index"),
        children: [
          {
            path: "",
            name: "tenant-users-home",
            component: () => import("@/views/tenant/users/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-users-add",
            component: () => import("@/views/tenant/users/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "details/:id",
            name: "tenant-users-details",
            component: () => import("@/views/tenant/users/details"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-users-edit",
            component: () => import("@/views/tenant/users/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "rewards",
        component: () => import("@/views/tenant/rewards/index"),
        children: [
          {
            path: "",
            name: "tenant-rewards-home",
            component: () => import("@/views/tenant/rewards/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-rewards-add",
            component: () => import("@/views/tenant/rewards/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "details/:id",
            name: "tenant-rewards-details",
            // component: () => import("@/views/tenant/rewards/details")
          },
          {
            path: "edit/:id",
            name: "tenant-rewards-edit",
            component: () => import("@/views/tenant/rewards/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "badges",
        component: () => import("@/views/tenant/badges/index"),
        children: [
          {
            path: "",
            name: "tenant-badges-home",
            component: () => import("@/views/tenant/badges/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-badges-add",
            component: () => import("@/views/tenant/badges/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-badges-edit",
            component: () => import("@/views/tenant/badges/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "instructor",
        component: () => import("@/views/tenant/instructor/index"),
        children: [
          {
            path: "",
            name: "tenant-instructor-home",
            component: () => import("@/views/tenant/instructor/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-instructor-add",
            component: () => import("@/views/tenant/instructor/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-instructor-edit",
            component: () => import("@/views/tenant/instructor/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "certificate",
        component: () => import("@/views/tenant/certificate/index"),
        children: [
          {
            path: "",
            name: "tenant-certificate-home",
            component: () => import("@/views/tenant/certificate/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-certificate-add",
            component: () => import("@/views/tenant/certificate/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-certificate-edit",
            component: () => import("@/views/tenant/certificate/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "notifications",
        component: () => import("@/views/tenant/notifications/index"),
        children: [
          {
            path: "",
            name: "tenant-notifications-home",
            component: () => import("@/views/tenant/notifications/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "prerequiste",
        component: () => import("@/views/tenant/prerequiste/index"),
        children: [
          {
            path: "",
            name: "tenant-prerequiste-home",
            component: () => import("@/views/tenant/prerequiste/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-prerequiste-add",
            component: () => import("@/views/tenant/prerequiste/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-prerequiste-edit",
            component: () => import("@/views/tenant/prerequiste/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "coupon",
        component: () => import("@/views/tenant/coupon/index"),
        children: [
          {
            path: "",
            name: "tenant-coupon-home",
            component: () => import("@/views/tenant/coupon/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-coupon-add",
            component: () => import("@/views/tenant/coupon/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-coupon-edit",
            component: () => import("@/views/tenant/coupon/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "gradable",
        component: () => import("@/views/tenant/gradable/index"),
        children: [
          {
            path: "",
            name: "tenant-gradable-home",
            component: () => import("@/views/tenant/gradable/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-gradable-add",
            component: () => import("@/views/tenant/gradable/create"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "labels",
        component: () => import("@/views/tenant/labels/index"),
        children: [
          {
            path: "",
            name: "tenant-labels-home",
            component: () => import("@/views/tenant/labels/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-labels-create",
            component: () => import("@/views/tenant/labels/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "update/:id",
            name: "tenant-labels-update",
            component: () => import("@/views/tenant/labels/update"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "leaderboard",
        component: () => import("@/views/tenant/leaderboard/index"),
        children: [
          {
            path: "",
            name: "tenant-leaderboard-home",
            component: () => import("@/views/tenant/leaderboard/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-leaderboard-add",
            component: () => import("@/views/tenant/leaderboard/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-leaderboard-edit",
            component: () => import("@/views/tenant/leaderboard/edit"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/:id",
            name: "tenant-leaderboard-single",
            component: () => import("@/views/tenant/leaderboard/single"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "courses",
        component: () => import("@/views/tenant/courses/index"),
        children: [
          {
            path: "",
            name: "tenant-courses",
            component: () => import("@/views/tenant/courses/home"),
            meta: {
              middleware: [auth],
            },
          },

        
          {
            path: "reminders/singe/:id",
            name: "tenant-course-reminder",
            component: () => import("@/views/tenant/courses/reminders/single"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-create-course",
            component: () => import("@/views/tenant/courses/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/:id",
            name: "tenant-single-course",
            component: () => import("@/views/tenant/courses/details"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "stats/:id",
            name:'tenant-course-stats',
            component: () => import("@/views/tenant/stats/index"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: ":id/lesson/create",
            name: "tenant-lesson-create",
            component: () => import("@/views/tenant/lessons/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/enrolles/:id",
            name: "tenant-course-enrolles",
            component: () => import("@/views/tenant/courses/enrolled"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-edit-course",
            component: () => import("@/views/tenant/courses/edit"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: ":id/modules",
            component: () => import("@/views/tenant/modules"),
            children: [
              {
                path: "",
                name: "tenant-course-modules-home",
                component: () => import("@/views/tenant/modules/home"),
                meta: {
                  middleware: [auth],
                },
              },

              {
                path: ":module",
                name: "tenant-single-module",
                component: () => import("@/views/tenant/modules/single"),
                meta: {
                  middleware: [auth],
                },
              },
              {
                path: "edit/:module_id",
                name: "tenant-modules-edit",
                component: () => import("@/views/tenant/modules/edit"),
                meta: {
                  middleware: [auth],
                },
              },
            ],
          },
        ],
      },
      {
        path: "webinar",
        component: () => import("@/views/tenant/webinar/index"),
        children: [
          {
            path: "",
            name: "tenant-webinar",
            component: () => import("@/views/tenant/webinar/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-create-webinar",
            component: () => import("@/views/tenant/webinar/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/:id",
            name: "tenant-single-webinar",
            component: () => import("@/views/tenant/webinar/details"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-edit-webinar",
            component: () => import("@/views/tenant/webinar/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },

      {
        path: "growth-plan",
        component: () => import("@/views/tenant/growth-plan/index"),
        children: [
          {
            path: "",
            name: "tenant-growth-plan",
            component: () => import("@/views/tenant/growth-plan/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-create-growth-plan",
            component: () => import("@/views/tenant/growth-plan/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-edit-growth-plan",
            component: () => import("@/views/tenant/growth-plan/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "submissions",
        component: () => import("@/views/tenant/submissions/index"),
        children: [
          {
            path: "",
            name: "tenant-submissions",
            component: () => import("@/views/tenant/submissions/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "single/:id",
            name: "tenant-single-submission",
            component: () => import("@/views/tenant/submissions/single"),
          },
        ],
      },
      {
        path: "lesson",
        component: () => import("@/views/tenant/lessons/"),
        children: [
          {
            path: ":lesson_id",
            name: "tenant-lesson-single",
            component: () => import("@/views/tenant/lessons/details"), // displaying a single lesson
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:lesson_id",
            name: "tenant-lesson-edit",
            component: () => import("@/views/tenant/lessons/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "quiz",
        component: () => import("@/views/tenant/quiz/index"),
        children: [
          {
            path: "",
            name: "tenant-quiz",
            component: () => import("@/views/tenant/quiz/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "add",
            name: "tenant-add-quiz",
            component: () => import("@/views/tenant/quiz/add"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "add/exercise",
            name: "tenant-add-exercise",
            component: () => import("@/views/tenant/quiz/add-exercise"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/exercise/:exercise_id",
            name: "tenant-edit-exercise",
            component: () => import("@/views/tenant/quiz/edit-exercise"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/:id",
            name: "tenant-single-quiz",
            component: () => import("@/views/tenant/quiz/details"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-edit-quiz",
            component: () => import("@/views/tenant/quiz/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "surveys",
        component: () => import("@/views/tenant/surveys/index"),
        children: [
          {
            path: "",
            name: "tenant-survey-home",
            component: () => import("@/views/tenant/surveys/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-survey-create",
            component: () => import("@/views/tenant/surveys/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:survey_id",
            name: "tenant-survey-edit",
            component: () => import("@/views/tenant/surveys/edit"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "summary/:survey_id",
            name: "tenant-survey-summary",
            component: () => import("@/views/tenant/surveys/summary"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "user/:survey_id/:learner_id",
            name: "tenant-survey-user",
            component: () => import("@/views/tenant/surveys/single_user"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "submission",
            name: "tenant-survey-submission",
            component: () => import("@/views/tenant/surveys/submission"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "resources",
        component: () => import("@/views/tenant/resources/index"),
        children: [
          {
            path: "",
            name: "tenant-resources",
            component: () => import("@/views/tenant/resources/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "add",
            name: "tenant-add-quiz",
            component: () => import("@/views/tenant/quiz/add"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "add/exercise",
            name: "tenant-add-exercise",
            component: () => import("@/views/tenant/quiz/add-exercise"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "view/:id",
            name: "tenant-single-quiz",
            component: () => import("@/views/tenant/quiz/details"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-edit-quiz",
            component: () => import("@/views/tenant/quiz/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "todo",
        component: () => import("@/views/tenant/todo/"),
        children: [
          {
            path: "",
            name: "tenant-todo-home",
            component: () => import("@/views/tenant/todo/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "tenant-todo-create",
            component: () => import("@/views/tenant/todo/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "tenant-todo-edit",
            component: () => import("@/views/tenant/todo/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "settings",
        component: () => import("@/views/tenant/settings"),
        children: [
          {
            path: "",
            name: "tenant-settings",
            component: () => import("@/views/tenant/settings/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "notification-settings",
        component: () => import("@/views/Shared/notification-settings"),
        children: [
          {
            path: "",
            name: "tenant-notification-settings",
            component: () =>
              import("@/views/Shared/notification-settings/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "profile",
        component: () => import("@/views/tenant/profile"),
        name: "tenant-profile",
      },

      {
        path: "/tenants/survey/submissions/:id",
        name: "tenant-survey-submission",
        component: () => import("@/views/tenant/survey_submission"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "create/article",
        name: "tenant-create-article",
        component: () => import("@/views/tenant/assets/article"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "article/edit/:article_id",
        name: "tenant-edit-article",
        component: () => import("@/views/tenant/assets/edit-article"),
        meta: {
          middleware: [auth],
        },
      },
    ],
  },
];
